import Wizard from "@/ts/components/members/wizard.vue";
import WizardPersonalInfo from "@/ts/components/members/wizard-personal-info.vue";
import WizardPeriod from "@/ts/components/members/wizard-period.vue";
import WizardSummary from "@/ts/components/members/wizard-summary.vue";
import WizardSuccess from "@/ts/components/members/wizard-success.vue";
import WizardRenewalDecision from "@/ts/components/members/wizard-renewal-decision.vue";
import { string } from "yup/lib/locale";

import Cancel from "@/ts/components/members/cancel.vue";
import CancelReason from "@/ts/components/members/cancel-reason.vue";
import CancelConfirmation from "@/ts/components/members/cancel-confirmation.vue";

interface MembershipData {
    personal_info: {
        first_name: string;
        last_name: string;
        email: string;
        phone: string;
        street: string;
        number: string;
        addition: string;
        postal_code: string;
        city: string;
        privacy: boolean;
        birth_date: string;
    };
    period: null | number;
}

interface CancelationData {
    reasons: {
        reason: string;
        comment?: string;
    };
}

export { MembershipData, Wizard, WizardRenewalDecision, WizardSuccess, WizardPersonalInfo, WizardPeriod, WizardSummary, Cancel, CancelReason, CancelationData, CancelConfirmation };
